<template>
  <div style="padding-top:35vh" v-if="isConfirming">
    <img alt=" " src="@/assets/main.gif" width="100px" style="display:block;margin:0 auto">
    <p align="center">Confirming your identity, Please wait...</p>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'

export default {
  name: 'EmailConfirmation',
  computed: {
    isConfirming: {
      get () { return this.$store.state.base.isConfirming }
    }
  },
  data() {
    return {
      key: null,
      username: null
    }
  },
  mounted () {
    this.key = ('key' in this.$route.query && this.$route.query.key) ? this.$route.query.key : null
    this.username = ('username' in this.$route.query && this.$route.query.username) ? this.$route.query.username : null

    if (this.key && this.username) {
      this.$store.dispatch('base/initiateConfirmation', {key: this.key, username: this.username}).then(
        res => {
          this.$Message({
            closable: true,
            durationInSec:5,
            title: { content:'Confirmed' },
            icon: 'checkmark',
            message: { content: 'Email address successfully confirmed.' },
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
            ]
          });          
          if (localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE'))
            this.$router.replace({path: '/home'})
          else
            this.$router.replace({path: '/login?type=signin'})
        }, err => {
          this.$router.replace({path: '/home'})
        });
    } else {
      this.$router.replace({path: '/home'})
    }
  }
}
</script>
